import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { startLive } from './sync/live';
// Order matters: the generated token variables must land before the stylesheet
// that overrides them (global.css rescales --k2-type-scale for wide screens).
import 'virtual:k2-tokens.css';
import './theme/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Loads the shop's state and keeps it in step with the other till. The screens
// render empty until the first answer arrives — a figure that looks like the
// shop's own but is not would be worse than a blank.
startLive();
